<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/stocktransfer" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("inventory.label.EditGRV") }}</h3>
          </li>
        </ul>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.Type')"
                  class="w-full mb-2 font-semibold"
                  v-model="createMrn.type"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("stockTransfer.label.Requested Date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('stockTransfer.label.Requested Date')"
                  >
                    <datepicker
                      v-model="createMrn.requestedDate"
                      :placeholder="$t('placeholder.label.SelectDate')"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockTransfer.label.Requested By")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('stockTransfer.label.Requested By')"
                  >
                    <vue-simple-suggest
                      v-model="createMrn.requestedBy"
                      value-attribute="id"
                      display-attribute="externalId"
                      :list="getMrnFalseSuggestionList"
                      class="w-full font-normal"
                      :filter-by-query="true"
                    >
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <span @click="changeCollectionfalse(suggestion)"
                          >{{ suggestion.name }} -- {{ suggestion.externalId }}
                        </span>
                      </div>
                    </vue-simple-suggest>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockTransfer.label.Request From")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('stockTransfer.label.Request From')"
                  >
                    <vue-simple-suggest
                      v-model="createMrn.requestFrom"
                      value-attribute="id"
                      display-attribute="externalId"
                      :list="getMrnTrueSuggestionList"
                      class="w-full font-normal"
                      :filter-by-query="true"
                    >
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <span @click="changeCollectionTrue(suggestion)"
                          >{{ suggestion.externalId }} --
                          {{ suggestion.name }}</span
                        >
                      </div>
                    </vue-simple-suggest>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Item") }}
                    <span class="required"> *</span>
                  </small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Item')"
                  >
                    <v-select
                      label="item"
                      v-model="selectedItem"
                      :options="itemList"
                      @input="selectedItems(selectedItem)"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('stockTransfer.label.Ordered Quantity')"
                >
                  <vs-input
                    :label="$t('stockTransfer.label.Ordered Quantity')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="createMrn.orderdQuantity"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Notes") }}
                    <span class="required"> *</span>
                  </small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Notes')"
                  >
                    <vs-textarea
                      :placeholder="$t('inventory.label.Notes')"
                      v-model="createMrn.notes"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" class="" @click="backToGoods"
              >{{ $t("stockTransfer.label.Cancel") }}
            </vs-button>
            <vs-button class="" @click="UpdateMrvBtn">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import {
  getMrnTemplate,
  getMrnFalse,
  getMrnTrue,
  getByGrvId,
  updateGrv,
} from "@/http/inventory";
import { ValidationObserver, ValidationProvider } from "vee-validate";
const createMrnEmptyObj = {
  type: "grv",
  requestedDate: "",
  requestedBy: "",
  requestFrom: "",
  itemDescription: 0,
  orderdQuantity: "",
  notes: "",
  fromOffice: 0,
  toOffice: 0,
};
export default {
  data() {
    return {
      createMrn: createMrnEmptyObj,
      createMrnPayload: {},
      mrnTemplate: {},
      dateFormat: "dd MMMM yyyy",
      itemList: [],
      selectedItem: "",
      mrnById: {},
      editItemId: "",
      editReqID: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    moment,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    async getByGrvId() {
      try {
        const response = await getByGrvId(this.id);
        this.mrnById = response.data;
        this.createMrn.requestedDate = this.mrnById.requestedDate;
        this.createMrn.requestedBy = this.mrnById.fromOffice;
        this.createMrn.requestFrom = this.mrnById.toOffice;
        this.selectedItem = this.mrnById.itemDescription;
        this.createMrn.orderdQuantity = this.mrnById.orderdQuantity;
        this.createMrn.notes = this.mrnById.notes;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving job by id:",
          error
        );
      }
    },
    async getMrnTemplate() {
      try {
        const resp = await getMrnTemplate();
        this.mrnTemplate = resp.data;
        this.mrnTemplate.officeData.forEach((element) => {
          if (this.mrnById.fromOffice == element.name) {
            this.createMrn.fromOffice = element.id;
          }
        });
        this.mrnTemplate.officeData.forEach((element) => {
          if (this.mrnById.toOffice == element.name) {
            this.createMrn.toOffice = element.id;
          }
        });
        this.mrnTemplate.itemMasterData.forEach((e) => {
          if (this.mrnById.itemDescription == e.itemCode) {
            this.editItemId = e.id;
          }
        });
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnFalseSuggestionList() {
      try {
        const response = await getMrnFalse(this.createMrn.requestedBy);
        return response.data.officeData;
      } catch (e) {
        console.log(
          "something went to wrong while retrieving client entity code :",
          e
        );
      }
    },
    async getMrnTrueSuggestionList() {
      try {
        const response = await getMrnTrue(this.createMrn.requestFrom);
        return response.data.officeData;
      } catch (e) {
        console.log(
          "something went to wrong while retrieving client entity code :",
          e
        );
      }
    },
    selectedItems(off) {
      this.mrnTemplate.itemMasterData.map((e) => {
        if (e.id + " -- " + e.itemCode == off) {
          this.createMrn.itemDescription = e.id;
        }
      });
    },
    changeCollectionfalse(e) {
      this.createMrn.fromOffice = e.id;
    },
    changeCollectionTrue(e) {
      this.createMrn.toOffice = e.id;
    },
    backToGoods() {
      this.$router.push("/inventory/stocktransfer");
    },
    async UpdateMrvBtn() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const itemData = this.mrnTemplate.itemMasterData.find(
        (item) => item.itemDescription === this.selectedItem
      );
      const formattedDate = moment(
        this.createMrn.requestedDate,
        "YYYY-MM-DD"
      ).format("DD MMMM YYYY");
      let payload = {
        itemId: itemData ? itemData.id : Number(this.createMrn.itemDescription),
        dateFormat: this.dateFormat,
        toOffice: this.createMrn.toOffice,
        // itemDescription: this.mrnById.itemDescription,
        locale: "en",
        notes: this.createMrn.notes,
        orderdQuantity: this.createMrn.orderdQuantity.toString(),
        requestedDate: formattedDate,
        requestedTime: moment().format(" h:mm:ss a"),
        fromOffice: this.createMrn.fromOffice,
        // type: this.createMrn.type,
      };
      await updateGrv(this.id, payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "GRV Edited Successfully!",
        type: "success",
      });
      this.$router.push("/inventory/stocktransfer");
    },

    resetForm() {
      this.createMrn = createMrnEmptyObj;
      (this.createMrn.requestedDate = ""),
        (this.createMrn.requestedBy = ""),
        (this.createMrn.requestFrom = ""),
        (this.createMrn.itemDescription = 0),
        (this.createMrn.orderdQuantity = ""),
        (this.createMrn.notes = "");
    },
  },
  watch: {
    mrnTemplate(val) {
      for (let role of val.itemMasterData) {
        this.itemList.push(role.id + " -- " + role.itemCode);
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.getByGrvId();
    await this.getMrnTemplate();
    await this.getMrnFalseSuggestionList();
  },
};
</script>
<style scoped></style>
